export function resolveReferralCode() {
	const params = new URLSearchParams(window.location.search);
	const fromUrl = (params.get("code") || "").trim();
	if (fromUrl) {
		try {
			localStorage.setItem("referralCode", fromUrl);
			sessionStorage.setItem("referralCode", fromUrl);
		} catch (e) { }
		return fromUrl;
	}

	try {
		return (localStorage.getItem("referralCode") || sessionStorage.getItem("referralCode") || "").trim();
	} catch (e) {
		try {
			return (sessionStorage.getItem("referralCode") || "").trim();
		} catch (ignored) {
			return "";
		}
	}
}

export function lookupGtmId(map, code) {
	if (!map || !code) {
		return "";
	}
	if (map[code]) {
		return map[code];
	}
	const lower = code.toLowerCase();
	const key = Object.keys(map).find((k) => k.toLowerCase() === lower);
	return key ? map[key] : "";
}

export function injectReferralGtm(containerId) {
	if (!containerId || typeof document === "undefined") {
		return;
	}
	const scriptId = "referral-gtm-" + containerId;
	if (document.getElementById(scriptId)) {
		return;
	}

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

	const script = document.createElement("script");
	script.id = scriptId;
	script.async = true;
	script.src = "https://www.googletagmanager.com/gtm.js?id=" + encodeURIComponent(containerId);
	document.head.appendChild(script);

	if (document.body) {
		const noscript = document.createElement("noscript");
		noscript.id = "referral-gtm-ns-" + containerId;
		const iframe = document.createElement("iframe");
		iframe.src = "https://www.googletagmanager.com/ns.html?id=" + encodeURIComponent(containerId);
		iframe.height = "0";
		iframe.width = "0";
		iframe.style.display = "none";
		iframe.style.visibility = "hidden";
		noscript.appendChild(iframe);
		document.body.insertBefore(noscript, document.body.firstChild);
	}
}

export function pushGtmEvent(event, extra) {
	if (!event) {
		return;
	}
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(extra ? { event, ...extra } : { event });
}

export function pushGtmSignUp() {
	pushGtmEvent("sign_up");
}

export function pushGtmPurchase(value, currency, transactionId) {
	const extra = {};
	if (value !== undefined && value !== null && value !== "") {
		const n = Number(value);
		if (!Number.isNaN(n)) {
			extra.value = n;
		}
	}
	if (currency) {
		extra.currency = currency;
	}
	if (transactionId) {
		extra.transaction_id = String(transactionId);
	}
	pushGtmEvent("purchase", extra);
}

